import { gql } from "urql";
// This is for the history of the last 100 conversations.
export const GetAIQuerySummaries = gql `
    query GetAIQuerySummaries($search: String, $offset: Int) {
        ai {
            querySummaries(search: $search, offset: $offset) {
                aiQuerySummaryId
                chatSeriesId
                summary
                createdAt
            }
        }
    }
`;
// This is for a new conversation, when the first ai response comes back,
// we can query the summary that was just generated.
export const GetAIQuerySummary = gql `
    query GetAIQuerySummary($chatSeriesId: String!) {
        ai {
            querySummary(chatSeriesId: $chatSeriesId) {
                summary
            }
        }
    }
`;
// This is for getting individual conversations, with many messages.
export const GetAIQueryChatSeries = gql `
    query GetAIQueryChatSeries($chatSeriesId: String!) {
        ai {
            queryChatSeries(chatSeriesId: $chatSeriesId) {
                aiQueryRequestId
                user {
                    userId
                    name
                    imageUrl
                }
                naturalLanguageQuery
                aiResponseNotes
                hasSql
                createdAt
            }
        }
    }
`;
